import { render, staticRenderFns } from "./opportunity-semester-summary.vue?vue&type=template&id=fd4db55e&scoped=true&"
import script from "./opportunity-semester-summary.vue?vue&type=script&lang=js&"
export * from "./opportunity-semester-summary.vue?vue&type=script&lang=js&"
import style0 from "./opportunity-semester-summary.vue?vue&type=style&index=0&id=fd4db55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4db55e",
  null
  
)

component.options.__file = "opportunity-semester-summary.vue"
export default component.exports